export const toArray = value => Array.isArray(value) ? value : [value];
export const notIn = (as, compare = (a, b) => a === b) => b => !as.some(a => compare(a, b));
export const range = (count, start = 0, step = 1) => {
  const _count = Math.floor(Math.abs(count));
  return Array.from({
    length: _count
  }, (_, i) => start + i * step);
};
